import React from "react";
import { YearsOfServiceContainer } from "../../../containers";

const ManageYearsOfService = (props) => {
  return <YearsOfServiceContainer {...props} />;
};

export default ManageYearsOfService;
